import { IconButton } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Tooltip } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { SearchMatchButtonProps as Props } from './types';

export const SearchMatchButton = memo(
  ({
    className,
    label,
    icon,
    type,
    selected,
    handleChange,
    disabled,
  }: Props) => {
    return (
      <Tooltip
        title={disabled ? 'Unavailable' : label}
        className={classnames('SearchMatchButton', className)}
        sx={SX.root}
        placement="top"
        enterDelay={1000}
        enterNextDelay={1000}
      >
        <span>
          <IconButton
            size="xsmall"
            variant="outlined"
            iconColor={
              disabled ? 'grey.400' : selected ? 'primary.600' : 'grey.600'
            }
            color={selected ? 'primary' : 'default'}
            iconSize={12}
            icon={icon}
            onClick={(e) => handleChange(e, type)}
            disabled={disabled}
          />
        </span>
      </Tooltip>
    );
  }
);

SearchMatchButton.displayName = 'SearchMatchButton';
